import { createSelector } from 'reselect'
import { GlobalStoreState } from 'src/Store'
import { User } from 'src/models'

const getUser = ({ auth }: GlobalStoreState): User => auth.user || new User({})

export const currentUserSelector = createSelector(getUser, (user) => user)
export const authLoadingSelector = ({ auth }: GlobalStoreState): boolean => auth.isFetching
